// module
import React from 'react';
import { Link } from 'react-router-dom';

// my components
import DownloadLinks from '../components/DownloadLinks';
import OptionTable from '../components/OptionTable';
import CommandBox from '../components/CommandBox';

// img
import singleDownloadImg from '../img/download_img.png';

function Gaap03Abyss(){
    window.scrollTo(0,0);
    return(
        <div className="content">
            <h2 className="content_title"><em>De novo</em> assembly </h2>
            <h2 className="content_title2">Genome assembly</h2>
            <div className="content_command_title">Abyss</div><br/>
            <div className="content_text">
                Abyss is a multistage de novo assembly tool consisting of 
                unitig (de Bruin graph), contig, and scaffold stages. 
                The recently published program Abyss 2.0 includes a Bloom 
                filter-based implementation of the unitig assembly stage, 
                which reduces the overall memory requirements.
            </div><br/>
            <li className="content_description">Download</li>
            <div className="content_download_box">
                <div className="content_download_img">
                    <img src={singleDownloadImg} alt="error"/>
                </div>
                <div className="content_download_links">
                    <br/><br/>
                    <DownloadLinks link="http://www.bcgsc.ca" />
                    <br/>
                </div>
            </div><br/>
            <li className="content_description">Abyss Command</li>
            <CommandBox lines={[
                {data:`abyss-pe k=kmerlength name=outprefix lib='pea peb' mp='mp1'`},
                {data:`pea='DNAread170_1.fastq DNAread170_2.fastq’ peb=’DNAread400_1.fastq DNAread400_2.fastq’`},
                {data:`mp1='DNAread2900_1.fastq DNAread2900_2.fastq'`},
            ]}
            /><br/>
            <li className="content_description">Options for Abyss</li>
            <OptionTable
                data={[
                    {   option:'k',
                        desc:'specify the k-mer length'},
                    {   option:'name',
                        desc:'specify the corresponding prefix of the output file name'},
                    {   option:'lib',
                        desc:'specify the paired-end libraries'},
                    {   option:'mp',
                        desc:'specify the mate-pair libraries'},    
                    {   option:'pea',
                        desc:'specify the file name of first paired-end library'},
                    {   option:'peb',
                        desc:'specify the file name of second paired-end library'},
                    {   option:'mp1',
                        desc:'specify the file name of mate-pair library'},   
                ]}
            /><br />
            <li className="content_description">Output of Abyss</li>
            <div className="content_text">
                outprefix-contigs.fa: stores the contigs.<br/>
                outprefix-scaffolds.fa: stores the scaffolds generated by de novo assembly.<br/>
            </div>
            <div className="content_buttons_div">
                <Link to="/Gaap03_AllPath"><button className="content_button">Pre&ensp;</button></Link>
                <Link to="/Gaap03_Velvet"><button className="content_button">Next</button></Link>
            </div>
        </div>
    );
}

export default Gaap03Abyss;